import { Controller } from "@hotwired/stimulus"

// Keeps a "live" marker honest while the page stays open: data-live is true
// only while the timestamp is inside the window, so a run that died mid-flight
// stops spinning on its own instead of until the next reload. The server sets
// the initial value; a morph that moves the timestamp re-evaluates it.
//
// Usage: data-controller="live-window" data-live-window-at-value="2026-09-02T12:00:00Z"
//        data-live-window-minutes-value="10" data-live-window-enabled-value="true"
export default class extends Controller {
  static values = {
    at: String,
    minutes: { type: Number, default: 10 },
    enabled: { type: Boolean, default: true }
  }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 30000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  atValueChanged() {
    this.update()
  }

  enabledValueChanged() {
    this.update()
  }

  update() {
    const at = Date.parse(this.atValue)
    const live = this.enabledValue && !Number.isNaN(at) && Date.now() - at < this.minutesValue * 60000
    this.element.setAttribute("data-live", live ? "true" : "false")
  }
}
